import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaChartLine, FaUsers, FaClipboardList, FaSitemap, FaUser, FaCog } from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ activeSection, setActiveSection }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNavClick = (sectionId) => {
    setActiveSection(sectionId);
    if (window.innerWidth <= 1024) {
      setIsMobileMenuOpen(false);
    }
  };

  const getRoleDisplay = (role) => {
    const roleMap = {
      superadmin: 'Super Admin',
      client: 'Client Admin',
      manager: 'Manager',
      employee: 'Employee'
    };
    return roleMap[role] || role;
  };

  const menuItems = [];

  if (user?.role === 'superadmin') {
    menuItems.push(
      { id: 'dashboard', label: 'Dashboard', icon: FaChartLine },
      { id: 'clients', label: 'Clients', icon: FaUsers },
      { id: 'readings', label: 'Consignments', icon: FaClipboardList },
      { id: 'settings', label: 'Settings', icon: FaCog }
    );
  } else if (user?.role === 'client') {
    menuItems.push(
      { id: 'dashboard', label: 'Dashboard', icon: FaChartLine },
      { id: 'hierarchy', label: 'Hierarchy', icon: FaSitemap },
      { id: 'readings', label: 'Consignments', icon: FaClipboardList }
    );
  } else if (user?.role === 'manager') {
    menuItems.push(
      { id: 'dashboard', label: 'Dashboard', icon: FaChartLine },
      { id: 'employees', label: 'Employees', icon: FaUser },
      { id: 'readings', label: 'Consignments', icon: FaClipboardList }
    );
  } else if (user?.role === 'employee') {
    menuItems.push(
      { id: 'dashboard', label: 'Dashboard', icon: FaChartLine },
      { id: 'readings', label: 'My Consignments', icon: FaClipboardList }
    );
  }

  return (
    <>
      {/* Mobile Menu Toggle Button */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      <div className={`sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand-container">
            <div className="sidebar-brand-prompt">prompt</div>
            <h2 className="sidebar-brand">MILKOCHECK</h2>
            <div className="sidebar-brand-tagline">digital alcohol test for milk</div>
          </div>
          <button 
            className="mobile-close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map(item => {
            const IconComponent = item.icon;
            return (
              <button
                key={item.id}
                className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => handleNavClick(item.id)}
              >
                <span className="nav-icon"><IconComponent /></span>
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-name">{user?.name}</div>
            <div className="user-role">{getRoleDisplay(user?.role)}</div>
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;

